import {createFileRoute} from '@tanstack/react-router';
import {AgreementPage} from 'features/agreement-cancellation/pages/AgreementPage/AgreementPage';

export const Route = createFileRoute('/_protected/agreements/$agreementId/')({
  component: AgreementPage,
  staticData: {crumbKey: 'navigation.agreements.cancel'},
});
